import { useTranslation } from '@/contexts/i18n-context';
import styles from './payment-options-page.module.css';
import { GradientFormTitle } from '@/components/containers/gradient-form-title';

export function PaymentOptionsPage() {
  const { t } = useTranslation();

  return (
    <GradientFormTitle className={styles.paymentOptions}>
      <h1 className="h4">{t('paymentOptions.title')}</h1>
      <p>{t('paymentOptions.description')}</p>
    </GradientFormTitle>
  );
}
